import { useCallback } from 'react';
import { useResetAtom } from 'jotai/utils';
import { dashboardFilterAtom } from './filterAtom';
import { dashboardColumnFilterModelAtom, dashboardColumnStateAtom } from './atoms';

/**
 * Resets all persisted dashboard filter state - the applied filters atom
 * (`dashboardFilterAtom`), AG Grid's column filter model
 * (`dashboardColumnFilterModelAtom`), and AG Grid's column state/layout
 * (`dashboardColumnStateAtom`, i.e. visibility/order/width/pinning chosen via
 * the sidebar's Columns tool panel) - back to their defaults, clearing
 * their localStorage entries in the process (same underlying `RESET`
 * behavior used by the "Clear Filters" button).
 *
 * Intended to be called on user logout, so a fresh session (whether the
 * same user logging back in or a different user on the same machine)
 * starts with a clean dashboard instead of inheriting stale filters or
 * column layout.
 */
export const useResetDashboardFilters = () => {
  const resetDashboardFilters = useResetAtom(dashboardFilterAtom);
  const resetDashboardColumnFilterModel = useResetAtom(
    dashboardColumnFilterModelAtom
  );
  const resetDashboardColumnState = useResetAtom(dashboardColumnStateAtom);

  return useCallback(() => {
    resetDashboardFilters();
    resetDashboardColumnFilterModel();
    resetDashboardColumnState();
  }, [
    resetDashboardFilters,
    resetDashboardColumnFilterModel,
    resetDashboardColumnState,
  ]);
};



